import queryString from "query-string";
export async function invokeCoreApiRaw(frontDoorUrl, path, method, options) {
    const token = await window.benderAuth.getToken();
    // easy usage of options
    const { parameters, query, body, headers } = options;
    // replace parameters in path
    let pathWithParameters = path;
    if (parameters !== undefined) {
        for (const [key, val] of Object.entries(parameters)) {
            pathWithParameters = pathWithParameters.replace(`{${key}}`, val);
        }
    }
    // prepare request parameters
    const url = `${frontDoorUrl}/api/core` + pathWithParameters + (query !== undefined ? `?${queryString.stringify(query)}` : "");
    const allHeaders = {
        ...headers,
        ...(body !== undefined ? { "Content-Type": "application/json" } : {}),
        Authorization: `Bearer ${token}`
    };
    const jsonBody = body !== undefined ? JSON.stringify(body) : undefined;
    return await fetch(url, { method: method, headers: allHeaders, body: jsonBody });
}
export async function invokeCoreApi(frontDoorUrl, path, method, options) {
    const response = await invokeCoreApiRaw(frontDoorUrl, path, method, options);
    return (await response.json());
}
//# sourceMappingURL=coreApiClient.js.map